import { SET_CROPPER_INFO } from '@/store/operations/types';

export default {
  name: 'functionsWithForms',
  data() {
    return {
      imageUrl: '',
    };
  },
  methods: {
    loadImage(file, commit = '') {
      try {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async () => {
          const img = new Image();
          img.src = reader.result.toString();
          img.onload = () => {
            if (img.width < 70 || img.width > 10000
              || img.height < 70 || img.height > 10000 || file.size > 5242880) {
              this.errorMessage = 'image size should be between 70x70 and 10000x10000 px';
              // eslint-disable-next-line no-console
              console.log('image size should be between 70x70 and 10000x10000 px',
                'current size: ', img.width, img.height);
            }
          };
          await img.onload;
          this.imageUrl = reader.result.toString();
          if (commit === SET_CROPPER_INFO) {
            this.$store.commit(SET_CROPPER_INFO, {
              src: img.src,
            });
          }
        };
        return null;
      } catch (e) {
        return e;
      }
    },
    cancelSubmit(commit, modal) {
      this.$store.commit(commit);
      this.$bvModal.hide(modal);
    },
  },
};
